import { COMPONENT_VALUE_TYPES as types } from 'shared/constants';

const propsSchema = [
  {
    key: 'page_title',
    label: 'Page Title',
    type: types.TEXT
  },
  {
    key: 'sections',
    label: 'Sections',
    type: types.ARRAY,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT
      },
      {
        key: 'tag',
        label: 'Tag',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'cta',
    label: 'CTA',
    type: types.ARRAY,
    children: [
      {
        key: 'label',
        label: 'Label',
        type: types.TEXT
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'hide_for_blocked_areas',
        label: 'Hide for Blocked Areas',
        type: types.BOOLEAN
      }
    ]
  },
  {
    key: 'options',
    label: 'Options',
    type: types.OBJECT,
    children: [
      {
        key: 'hide_for_small_screen',
        label: 'Hide For Small Screen (960px)',
        type: types.BOOLEAN
      }
    ]
  }
];

const defaultProps = {
  page_title: 'FF 91',
  sections: [
    { label: 'Design', tag: 'design' },
    { label: 'Performance', tag: 'performance' },
    { label: 'Technology', tag: 'technology' },
    { label: 'Interior', tag: 'interior' }
  ],
  cta: [{
    label: 'Preorder',
    url: '/preorder',
    hide_for_blocked_areas: false
  }]
};

export default {
  title: 'Sticky Sub Nav',
  id: 'StickySubNav',
  propsSchema,
  defaultProps
};
